import { LogoHeader } from '../../Components/Inicio/LogoHeaderComponent';
import { Footer } from '../../Components/Footer/FooterComponent';
import { NavMobile } from '../../Components/Inicio/NavMobile';
import { NavDesktop } from '../../Components/Inicio/NavDesktop';
import HistoriaComponent from '../../Components/Historico/HistoriaComponent';

export const HistoriaPage = (props) => {
    return(
        <>
            <LogoHeader I18n={props.I18n}/>
            <NavDesktop I18n={props.I18n}/>
            <NavMobile I18n={props.I18n}/>
            <HistoriaComponent I18n={props.I18n}/>
            <Footer I18n={props.I18n}/>
        </>
    );
}